import{baseRadioPropDefs as a}from"./base-radio.props.js";export{a as radioPropDefs};
//# sourceMappingURL=radio.props.js.map
